module.exports = __webpack_public_path__ + "img/icon-wman.752735b4.png";